import React, { Component } from 'react'
import '../styles/TargetCropSelection.css'
import '../styles/MarketChainStudy.css'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIClusterRequest from '../api/APIClusterRequest'

class TargetCropSelectionList extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: JSON.parse(localStorage.getItem("siteId")),
			clusterId: sessionStorage.getItem("cluster-id"),
			site: props.site,
		}
		this.onAddClick = this.onAddClick.bind(this)
		this.viewDetails = this.viewDetails.bind(this)
		this.handleSearch = this.handleSearch.bind(this)
		this.filterByDate = this.filterByDate.bind(this)
		this.filterByStatusId = this.filterByStatusId.bind(this)
		this.getAllTargetCropsByClusterId = this.getAllTargetCropsByClusterId.bind(this)
		this.getTargetCropById = this.getTargetCropById.bind(this)
	}

	componentWillMount() {
		this.setState({showActivityIndicator: true})
		this.getAllTargetCropsByClusterId()
	}

	getAllTargetCropsByClusterId() {
		const clusters = APIClusterRequest.getAllTargetCropsByClusterId(this.state.accessToken, this.state.clusterId)
		clusters.then((response) => {
			console.log('getAllTargetCropsByClusterId', response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			let totalArea = 0
			let count = 0
			const tcbc = []
			response.results.rows.map((item, i) => {
				console.log('item', item)
				this.getTargetCropById(item.target_crop_id , (area) => {
					totalArea += area
					console.log('area', area, totalArea)
					count++
					console.log(response.results.count, count)
					item['total_area_planted'] = area
					tcbc.push(item)
					console.log('tcbc', tcbc)

					tcbc.sort((a, b) => {
						return(a.crop.localeCompare(b.crop))
					})

					if(response.results.count === count) {
						this.setState({
							showActivityIndicator: false,
							allTargetCrops: tcbc
						})
					}
				})
			})
		})
	}

	getTargetCropById(targetCropId, callback) {
		const cluster = APIClusterRequest.getTargetCropById(this.state.accessToken, targetCropId)
		cluster.then((response) => {
		console.log("getTargetCropById", response)
			console.log(response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			if(response.status === "ERROR") {
				this.setState({
					showWarningMessage: true,
					aMessage: response.status + "! " + response.description,
					showActivityIndicator: false
				})
				return
			}
			const ics = {}
			let totalArea = 0
			for(const v of response.results.initialCommitment) {
				totalArea += v.area_planted
			}
			callback(totalArea)
		})
	}

	onAddClick() {
		this.props.onAddClick("cch-target-form")
	}

	viewDetails(pbid) {
		this.props.viewDetails(pbid)
	}

	handleSearch(searchVal) {
		if(searchVal == null || this.state.allClusters == null) {
			this.setState({listData: null})
			return
		}
		const byTarget = []
		for(const v of this.state.allClusters) {
			if(searchVal.cropId == 0 || searchVal.cropId == null) {
				byTarget.push(v)
			}
			else {
				if(searchVal.crop === v.crop) {
					byTarget.push(v)
				}
			}
		}
		const dateSelected = {
			dateFormed: searchVal.dateFormed,
			dateFrom: searchVal.dateFrom,
			dateTo: searchVal.dateTo
		}
		if(searchVal.statusId != null && searchVal.statusId !== "") {
			this.filterByStatusId(searchVal.statusId, byTarget, (at) => {
				this.filterByDate(dateSelected, at, (bd) => {
					this.setState({listData: bd})
				})
			})
			return
		}
		this.filterByDate(dateSelected, byTarget, (bd) => {
			this.setState({listData: bd})
		})
	}

	filterByStatusId(statId, crops, callback) {
		const at = []
		for(const v of crops) {
			if(statId == v.is_active) {
				at.push(v)
			}
		}
		callback(at)
	}

	filterByDate(dateSelected, clusters, callback) {
		const dr = new Date(dateSelected.dateFormed)
		const df = new Date(dateSelected.dateFrom)
		const dt = new Date(dateSelected.dateTo)
		const cls = []
		for(const v of clusters) {
			const ds = new Date(v.date_formed)
			if(dateSelected.dateFormed == null) {
				cls.push(v)
				continue
			}
			if(dateSelected.dateFormed.toLowerCase() === "any") {
				cls.push(v)
			}
			else if(dr.getMonth() === ds.getMonth() && dr.getDate() === ds.getDate() && dr.getFullYear() === ds.getFullYear()) {
				cls.push(v)
			}
			else if(ds >= df && ds < dt) {
				cls.push(v)
			}
		}
		callback(cls)
	}

	render() {
		return(<div id="tcs-list">
			<div id="tcs-listview"><TCSListView data={this.state.allTargetCrops}
				onAddClick={this.onAddClick}
				viewDetails={this.viewDetails} />
			</div>
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>)
	}
}

class TCSListView extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			searchLabel: (props.data != null)? props.data.count + " result(s)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
			listItems: [],
			onAddClick: props.onAddClick
		}
		this.viewDetails = this.viewDetails.bind(this)
	}

	viewDetails(pbid) {
		this.props.viewDetails(pbid)
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data) {
			console.log('TCSListView -->', this.props.data)
			const listItems = []
			if(this.props.data != null) {
				for(const v of this.props.data) {
					listItems.push(<ListItem data={v} viewDetails={this.viewDetails} />)
				}
			}
			this.setState({
				searchLabel:  (this.props.data != null)? this.props.data.length + " RESULT(S)": "PRESS THE SEARCH BUTTON TO SEE RESULTS",
				listItems: listItems
			})
		}
	}

	render() {
		return(<div className="tcs-lv">
			<div className="blv-header">
				<table className="blv-table-header">
					<col style={{width: '34%'}} />
					<col style={{width: '33%'}} />
					<col style={{width: '33%'}} />
					<tr>
						<th>FOCUS CROP</th>
						<th>UNIT OF MEASUREMENT</th>
						<th>TOTAL AREA PLANTED (has)</th>
						<div className="blv-grid-btn"><button className="green-two" onClick={(e) => {
								this.state.onAddClick()
							}}>ADD</button>
						</div>
					</tr>
				</table>
			</div>
			<div className="blv-items">{this.state.listItems}</div>
			{this.state.listItems.length < 1 && <div className="blv-result"><div>NO RESULT</div></div>}
		</div>)
	}
}

function ListItem(props) {
	return(<div className="blv-list-item">
			<table className="blv-table-data">
				<col style={{width: '34%'}} />
				<col style={{width: '33%'}} />
				<col style={{width: '33%'}} />
				<tr>
					<td>{props.data.crop}</td>
					<td>{props.data.unit_of_measurement}</td>
					<td>{props.data.total_area_planted}</td>
					<div className="blv-grid-btn"><button className="btn-view-details" onClick={(e) => {
							props.viewDetails(props.data.target_crop_id)
						}}>VIEW DETAILS</button>
					</div>
				</tr>
			</table>
	</div>)
}

export default TargetCropSelectionList
